enum EDSFieldStatus {
  DEFAULT = 'default',
  ERROR = 'error',
  SUCCESS = 'success',
}

export default EDSFieldStatus;
